<ng-container *ngIf="onderneming$ | async as onderneming">
  <app-header *ngIf="shouldShowHeader$ | async"
              [onderneming]="onderneming"></app-header>
  <router-outlet></router-outlet>

  <div *ngIf="isLoading" class="w-100 h-100 text-center">
    <div class="row justify-content-center">
      <div class="spinner-border spinner  mt-5" style=" width: 6rem; height: 6rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</ng-container>
